import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { observable, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { OrderShuttlePlanReportVM } from '../models/OrderShuttlePlanning.models';
import { EditOrderShuttle, OrderShuttleVM } from '../models/orderModel';

@Injectable({
  providedIn: 'root'
})
export class OrderShuttleService {
  hostPath: string = JSON.parse(environment.IDENTITY);
  orderShuttlePath = 'Shuttlebuss/Shuttlebuss.Service/ordershuttle';

  constructor(private http: HttpClient) {}

  public getOrderShuttle(orderShuttleId: string): Observable<OrderShuttleVM> {
    const URL = `${this.hostPath}${this.orderShuttlePath}/ordershuttle/${orderShuttleId}`;
    return this.http.get<OrderShuttleVM>(URL).pipe(
      map(ordershuttle => {
        return ordershuttle;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderShuttleOrderId(orderId: string): Observable<OrderShuttleVM[]> {
    const URL = `${this.hostPath}${this.orderShuttlePath}/ordershuttlesorderid/${orderId}`;
    return this.http.get<OrderShuttleVM[]>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderShuttlesPaidOrganizationBetweenShuttleDate(organizationId: string, shuttleDateFrom: string, shuttleDateTo: string): Observable<any> {
    const URL = `${this.hostPath}${this.orderShuttlePath}/ordershuttles/${organizationId}/${shuttleDateFrom}/${shuttleDateTo}`;
    return this.http.get<any>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderShuttlesPlanning(shuttleDateFrom: string, shuttleDateTo: string): Observable<OrderShuttlePlanReportVM> {
    const URL = `${this.hostPath}${this.orderShuttlePath}/ordershuttlesplanning/${shuttleDateFrom}/${shuttleDateTo}`;
    return this.http.get<OrderShuttlePlanReportVM>(URL).pipe(
      map(orderShuttlesPlanning => {
        return orderShuttlesPlanning;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderShuttlesArrival(arrivalId: string) {
    const URL = `${this.hostPath}${this.orderShuttlePath}/ordershuttlesarrival/${arrivalId}`;
    return this.http.get<any>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderShuttlesDeparture(departureId: string) {
    const URL = `${this.hostPath}${this.orderShuttlePath}/ordershuttlesdeparture/${departureId}`;
    return this.http.get<any>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderShuttlesPaidBus(orderShuttleBusId: string) {
    const URL = `${this.hostPath}${this.orderShuttlePath}/getordershuttlespaid/${orderShuttleBusId}`;
    return this.http.get<any>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderShuttlesBoardedBus(orderShuttleBusId: string) {
    const URL = `${this.hostPath}${this.orderShuttlePath}/getordershuttlesboarded/${orderShuttleBusId}`;
    return this.http.get<any>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderShuttlesPickup(): Observable<OrderShuttleVM[]> {
    const URL = `${this.hostPath}${this.orderShuttlePath}/getordershuttlespickup`;
    return this.http.get<OrderShuttleVM[]>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public editOrderShuttle(editOrderShuttle: EditOrderShuttle): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = `${this.hostPath}${this.orderShuttlePath}/editordershuttle`;
    return this.http
      .post<EditOrderShuttle>(url, editOrderShuttle, { headers })
      .pipe(map(orderShuttleVM => {
          return orderShuttleVM;
        }),
        catchError(this.handleError)
      );
  }

  public setOrderShuttleBoarded(orderShuttleId: string, orderShuttleBusId) {
    const URL = `${this.hostPath}${this.orderShuttlePath}/setordershuttleboarded/${orderShuttleId}/${orderShuttleBusId}`;
    return this.http.get<any>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public setOrderShuttleNoShow(orderShuttleId: string) {
    const URL = `${this.hostPath}${this.orderShuttlePath}/setordershuttlenoshow/${orderShuttleId}`;
    return this.http.get<any>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public setOrderShuttleReadyForPickup(orderShuttleId: string) {
    const URL = `${this.hostPath}${this.orderShuttlePath}/setordershuttlereadyforpickup/${orderShuttleId}`;
    return this.http.get<any>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public setOrderShuttlePaid(orderShuttleId: string) {
    const URL = `${this.hostPath}${this.orderShuttlePath}/setordershuttlepaid/${orderShuttleId}`;
    return this.http.get<any>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public setPassengers(orderId: string, passengers: string): Observable<OrderShuttleVM[]> {
    const URL = `${this.hostPath}${this.orderShuttlePath}/setpassengers/${orderId}/${passengers}`;
    return this.http.get<OrderShuttleVM[]>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(`orderShuttleService.handleError ${errMsg}`);
    return throwError(error);
  }
}
